<template>
    <div class="oc-checkbox-group">
        <template v-if="layout === 'vertical'">
            <oc-row>
                <oc-col v-for="chunkNum in getChunksCount(optionsConverted)" :key="'col-' + chunkNum">
                    <template v-for="(option, key) in getChunk(optionsConverted, chunkNum)">
                        <div
                            :key="key"
                            class="custom-control custom-checkbox"
                        >
                            <oc-checkbox-input
                                :name="option.name"
                                :value="option.value"
                                :data="data"
                                :id="getIdentifier(option)"
                                :disabled="disabled || isDisabled(option)"
                                v-bind="option.inputAttrs"
                                v-on="$listeners"
                                class="custom-control-input"
                            />

                            <oc-label-input
                                :for="getIdentifier(option)"
                                v-bind="option.labelAttrs"
                                class="custom-control-label"
                            >
                                <slot name="label" v-bind="{option, selected: isSelected(option), labelAttrs: option.labelAttrs}">
                                    {{option.text}}
                                </slot>
                            </oc-label-input>
                        </div>
                    </template>
                </oc-col>
            </oc-row>
        </template>
        <template v-else>
            <oc-row v-for="chunkNum in getChunksCount(optionsConverted)" :key="'row-' + chunkNum">
                <oc-col>
                    <div
                        v-for="(option, key) in getChunk(optionsConverted, chunkNum)"
                        :key="key"
                        class="custom-control custom-checkbox custom-control-inline"
                    >
                        <oc-checkbox-input
                            :name="option.name"
                            :value="option.value"
                            :data="data"
                            :id="getIdentifier(option)"
                            :disabled="disabled || isDisabled(option)"
                            v-bind="option.inputAttrs"
                            v-on="$listeners"
                            class="custom-control-input"
                        />

                        <oc-label-input
                            :for="getIdentifier(option)"
                            v-bind="option.labelAttrs"
                            class="custom-control-label"
                        >
                            <slot name="label" v-bind="{option, selected: isSelected(option), labelAttrs: option.labelAttrs}">
                                {{option.text}}
                            </slot>
                        </oc-label-input>
                    </div>
                </oc-col>
            </oc-row>
        </template>
    </div>
</template>

<script>
import OptionsHandlerMixin from '@/components/form/base/helpers/OptionsHandlerMixin'
import ChunkMixin from '@/mixins/ChunkMixin'

export default {
    name: 'oc-checkbox-group-input',
    mixins: [OptionsHandlerMixin, ChunkMixin],
    props: {
        id: {
            default: ''
        },
        data: {
            type: [Array, Object],
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        useTextAsValue: {
            type: Boolean,
            default: false
        },
        useValueAsName: {
            type: Boolean,
            default: false
        },
        layout: {
            type: String,
            default: 'inline',
            validator: function (value) {
                return ['vertical', 'inline'].indexOf(value) !== -1
            }
        }
    },
    model: {
        prop: 'data',
        event: 'input'
    },
    created() {
        if ( isObject(this.data) && isObject(this.options) && ! this.useValueAsName ) {
            console.error(`[CheckboxRadioInput] You are using object for property "data". You should provide "name" for each checkbox in order to properly fill data object.`)
        }
    },
    methods: {
        getIdentifier(option){
            let id = this.id
            if( ! id && option.name ) {
                id = option.name.replace(/\./g, '-')
            }

            return 'oc-checkbox-group-' + id + '-' + option.value
        },
        isSelected(option) {
            if (isObject(this.data)) {
                if( ! this.data.hasOwnProperty(option.name) )
                    return false

                return this.data[option.name] === option.value
            }
            else if (isArray(this.data)) {
                return this.data.indexOf( option.value ) > -1
            }

            return false
        }
    },
    computed: {
        optionsConverted() {
            let options = OptionsHandlerMixin.computed.optionsConverted.call(this)

            let prepared = []

            options.forEach( (opt, index) => {
                if( opt.labelAttrs === undefined ) {
                    opt.labelAttrs = {}
                }

                if( opt.inputAttrs === undefined ) {
                    opt.inputAttrs = {}
                }

                if( this.useTextAsValue && (this.options[index] === undefined || this.options[index].value === undefined) ) {
                    opt.value = String(opt.text)
                }

                if( this.useValueAsName && (this.options[index] === undefined || this.options[index].name === undefined) ) {
                    opt.name = opt.value
                }

                if( this.isVisible(opt) ) {
                    prepared.push(opt)
                }
            })

            return prepared
        }
    }
}
</script>
